module.exports = __webpack_public_path__ + "img/27.f05f878f.jpg";